import type { Contact } from '@app/types'
import { publicAssetPath } from '@app/utils/images.utils'

/**
 * Returns the full name of a contact
 */
export const getFullName = (contact: Contact): string => {
  return `${contact.firstName} ${contact.lastName}`
}

/**
 * Returns the image source path for a contact's image
 */
export const getImageSource = (contact: Contact): string => {
  return publicAssetPath(`images/staff/${contact.image}`)
}
